import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase requires appId. If it's missing (env var not set), we log a clear
// message instead of crashing the whole page with a blank screen.
const appId = process.env.REACT_APP_FIREBASE_APP_ID;

if (!appId) {
  // eslint-disable-next-line no-console
  console.error(
    "[JB+ Payment] REACT_APP_FIREBASE_APP_ID is not set in .env\n" +
    "Go to Firebase Console → Project Settings → Your apps → Add app → Web\n" +
    "Copy the appId and add it to janmabhoomi-payment/.env"
  );
}

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             appId || "1:36386092955:web:placeholder",
};

// Avoid re-initialising on hot reload
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;
